//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        dataList: {
            type: Object,
            default: () => {},
        },
        is_text: {
            type:Boolean,
            default: true
        }
    },
    computed:{
        Obj(){ 
            let type = 0
            let proportion = (this.dataList.actual / this.dataList.planned)
            let pro = ''
            if(proportion == 0){
                type = 0
            }else if(proportion == 1){
                type = 2
            }else{
                type = 1
                pro = (proportion.toFixed(2) - 0) * 100
            }
            let msg = {...this.dataList}
            msg.type = type
            msg.pro =  Math.round(pro)  
            return msg
        }
    },
    data(){
        return{

        }
    },
    mounted(){
        
    },
    methods: {
        
    }

}





// WEBPACK FOOTER //
// ./src/components/home/component/Progress.vue